// extracted by mini-css-extract-plugin
module.exports = {"icon":"useLongPress_icon__1anCz"};